import type { AvailableLayer } from '@civilgrid/utils/src/layerConfig/availableLayerTypes';
import { getAxiosClient } from './common';

const axios = getAxiosClient();

// ---------------------------------------------------------------------------
// Available-layer catalog — client API over
// `GET /v1/availableLayers`.
//
// The wire types are shared with the server via the import-free
// `@civilgrid/utils/src/layerConfig/availableLayerTypes`, so the two sides can't drift.
// (The document types in `api/layerConfig.ts` / `api/orgLayerConfig.ts` remain client-side
// duplicates — owned by `@civilgrid/db`, which cannot be bundled.)
// ---------------------------------------------------------------------------

export type {
  AvailableLayer,
  AvailableLayerAncestor,
  AvailableSubLayer,
} from '@civilgrid/utils/src/layerConfig/availableLayerTypes';

const AVAILABLE_LAYERS_PATH = '/v1/availableLayers';

/**
 * `GET /v1/availableLayers?organizationId=`. Returns the org's already-scoped
 * catalog in group grain. Rejects on failure (including a non-member 403); the React Query
 * hook surfaces it as its error state.
 */
export async function getAvailableLayers(organizationId: string): Promise<AvailableLayer[]> {
  const { data } = await axios.get<AvailableLayer[]>(AVAILABLE_LAYERS_PATH, {
    params: { organizationId },
  });
  return data;
}
